import React from 'react';

// bootstrap
import Button from 'react-bootstrap/Button';

// redux
import { useSelector } from 'react-redux';
import { selectOneRetailer } from '_redux/slices/marketplace/retailer';

// custom components
import RetailerTitle from './components/retailer-title';

const TermsAndConditions = () => {

    // redux
    const retailer = useSelector(selectOneRetailer);                                // retailer object
    
    const handleLogoClick = () => {

    }

    const handleReturn = () => {
        // go back
        window.history.back();
    }

    return (
        <div>

            <RetailerTitle retailer={retailer} handleLogoClick={handleLogoClick} />

            <div style={styles.container}>
                
                <Button style={styles.button} onClick={handleReturn} variant="primary">
                    Return
                </Button>


                <h1 style={styles.heading}>Terms and Conditions</h1>
                <p style={{ fontStyle: 'italic' }}>
                    Last updated: 2 July 2025
                </p>


                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>1. Introduction</h5>
                    <p>
                        These Terms and Conditions ("Terms", "Terms and Conditions") govern your relationship with the PRM AssistMarketplace platform (the "Service") operated by PRM Assist Limited ("us", "we", or "our"). By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the terms, please do not use the Service.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>2. Accounts</h5>
                    <p>
                        When you create an account with us, you must provide accurate, complete, and current information. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>3. Orders</h5>
                    <p>
                        By placing an order through our Service, you warrant that you are legally capable of entering into binding contracts. All orders are subject to availability and confirmation of the order price. We reserve the right to cancel or refuse any order at our discretion.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>4. Product Comments</h5>
                    <p>
                        Users may attach special instructions or comments to individual items in their order (e.g., "Oat milk instead of dairy"). These comments are submitted at the time of ordering and are not retained beyond the current transaction. It is the responsibility of the user to ensure these comments are accurate and appropriate.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>5. Pricing and Payment</h5>
                    <p>
                        All prices are listed in EUR and are inclusive of applicable taxes unless stated otherwise. Payment must be received in full before the order is processed. We accept most major debit/credit cards and online payment methods.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>6. Cancellations and Refunds</h5>
                    <p>
                        You may cancel your order within 2 minutes of placing it. Once the order is in progress or has been dispatched, it cannot be cancelled. Refunds will only be issued for valid complaints or errors approved by our support team.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>7. Intellectual Property</h5>
                    <p>
                        The Service and its original content, features, and functionality are and will remain the exclusive property of PRM Assist Limited and its licensors.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>8. Limitation of Liability</h5>
                    <p>
                        To the maximum extent permitted by law, PRM Assist Limited shall not be liable for any indirect, incidental, special, or consequential damages resulting from your use of the Service.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>9. Changes to These Terms</h5>
                    <p>
                        We reserve the right to modify or replace these Terms at any time. Any changes will be posted on this page with an updated date.
                    </p>
                </section>

                <section style={styles.section}>
                    <h5 style={styles.sectionTitle}>10. Contact Us</h5>
                    <p>
                        If you have any questions about these Terms, please contact us at <a href="mailto:marketplacesupport@prmassist.com">marketplacesupport@prmassist.com</a>
                    </p>
                </section>

                                
                <Button style={styles.button} onClick={handleReturn} variant="primary">
                    Return
                </Button>
                
            </div>
        
        </div>
    );
};

const styles = {
    container: {
        padding: '40px 20px',
        maxWidth: 800,
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        lineHeight: 1.6,
        color: '#333',
    },
    heading: {
        fontSize: '32px',
        marginBottom: '20px',
        marginTop:12
    },
    section: {
        marginBottom: '30px',
    },
    sectionTitle: {
        fontWeight: 'bold'
    }
};

export default TermsAndConditions;
